// Language to country mapping for world map highlighting
export const languageRegions = {
  'English': [
    'United States of America', 'United Kingdom', 'Canada', 'Australia', 'New Zealand', 
    'Ireland', 'South Africa', 'India', 'Pakistan', 'Nigeria', 'Kenya', 'Uganda', 
    'Tanzania', 'Ghana', 'Zimbabwe', 'Botswana', 'Namibia', 'Zambia', 'Malawi', 
    'Sierra Leone', 'Liberia', 'Gambia', 'Malta', 'Cyprus', 'Fiji', 'Papua New Guinea',
    'Solomon Islands', 'Vanuatu', 'Samoa', 'Tonga', 'Barbados', 'Jamaica', 'Trinidad and Tobago',
    'Guyana', 'Belize', 'Bahamas', 'Antigua and Barbuda', 'Saint Lucia', 'Saint Vincent and the Grenadines',
    'Grenada', 'Dominica', 'Saint Kitts and Nevis', 'Seychelles', 'Mauritius', 'Singapore',
    'Malaysia', 'Brunei', 'Philippines', 'Hong Kong', 'Macao'
  ],
  'Hindi': ['India', 'Nepal', 'Fiji', 'Mauritius', 'Suriname', 'Guyana', 'Trinidad and Tobago'],
  'Spanish': [
    'Spain', 'Mexico', 'Argentina', 'Colombia', 'Peru', 'Venezuela', 'Chile', 'Ecuador',
    'Guatemala', 'Cuba', 'Bolivia', 'Dominican Republic', 'Honduras', 'Paraguay', 'Nicaragua',
    'El Salvador', 'Costa Rica', 'Panama', 'Uruguay', 'Puerto Rico', 'Equatorial Guinea'
  ],
  'French': [
    'France', 'Canada', 'Belgium', 'Switzerland', 'Luxembourg', 'Monaco', 'Algeria', 'Morocco',
    'Tunisia', 'Senegal', 'Mali', 'Burkina Faso', 'Niger', 'Chad', 'Central African Republic',
    'Democratic Republic of the Congo', 'Republic of the Congo', 'Gabon', 'Cameroon',
    'Ivory Coast', 'Guinea', 'Madagascar', 'Benin', 'Togo', 'Rwanda', 'Burundi', 'Djibouti',
    'Comoros', 'Seychelles', 'Vanuatu', 'New Caledonia', 'French Polynesia', 'Haiti'
  ],
  'German': ['Germany', 'Austria', 'Switzerland', 'Luxembourg', 'Liechtenstein', 'Belgium'],
  'Portuguese': ['Portugal', 'Brazil', 'Angola', 'Mozambique', 'Guinea-Bissau', 'Cape Verde', 'São Tomé and Príncipe', 'East Timor', 'Macao'],
  'Italian': ['Italy', 'San Marino', 'Vatican City', 'Switzerland'],
  'Russian': ['Russia', 'Belarus', 'Kazakhstan', 'Kyrgyzstan', 'Tajikistan', 'Moldova', 'Georgia', 'Armenia', 'Azerbaijan'],
  'Chinese': ['China', 'Taiwan', 'Singapore', 'Malaysia', 'Hong Kong', 'Macao'],
  'Japanese': ['Japan'],
  'Korean': ['South Korea', 'North Korea'],
  'Arabic': [
    'Saudi Arabia', 'Egypt', 'Iraq', 'Jordan', 'Lebanon', 'Syria', 'Yemen', 'Kuwait',
    'United Arab Emirates', 'Qatar', 'Bahrain', 'Oman', 'Libya', 'Sudan', 'Algeria',
    'Morocco', 'Tunisia', 'Mauritania', 'Somalia', 'Djibouti', 'Comoros', 'Chad'
  ],
  'Dutch': ['Netherlands', 'Belgium', 'Suriname'],
  'Swedish': ['Sweden', 'Finland'],
  'Norwegian': ['Norway'],
  'Danish': ['Denmark'],
  'Finnish': ['Finland'],
  'Polish': ['Poland'],
  'Czech': ['Czech Republic'],
  'Hungarian': ['Hungary'],
  'Romanian': ['Romania', 'Moldova'],
  'Bulgarian': ['Bulgaria'],
  'Greek': ['Greece', 'Cyprus'],
  'Turkish': ['Turkey', 'Cyprus'],
  'Hebrew': ['Israel'],
  'Persian': ['Iran', 'Afghanistan', 'Tajikistan'],
  'Urdu': ['Pakistan', 'India'],
  'Bengali': ['Bangladesh', 'India'],
  'Tamil': ['India', 'Sri Lanka', 'Singapore', 'Malaysia'],
  'Telugu': ['India'],
  'Marathi': ['India'],
  'Gujarati': ['India'],
  'Kannada': ['India'],
  'Malayalam': ['India'],
  'Punjabi': ['India', 'Pakistan'],
  'Thai': ['Thailand'],
  'Vietnamese': ['Vietnam'],
  'Indonesian': ['Indonesia'],
  'Malay': ['Malaysia', 'Brunei', 'Singapore', 'Indonesia'],
  'Tagalog': ['Philippines'],
  'Swahili': ['Kenya', 'Tanzania', 'Uganda', 'Rwanda', 'Burundi', 'Democratic Republic of the Congo'],
  'Amharic': ['Ethiopia'],
  'Yoruba': ['Nigeria', 'Benin', 'Togo'],
  'Igbo': ['Nigeria'],
  'Hausa': ['Nigeria', 'Niger', 'Chad', 'Ghana', 'Cameroon'],
  'Zulu': ['South Africa'],
  'Afrikaans': ['South Africa', 'Namibia'],
  'Xhosa': ['South Africa']
};

// Helper function to get countries for active languages
export const getCountriesForLanguages = (activeLanguages) => {
  const countries = new Set();
  activeLanguages.forEach(language => {
    const regions = languageRegions[language];
    if (regions) {
      regions.forEach(country => countries.add(country));
    }
  });
  return Array.from(countries);
};